// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ccd-dialog .el-dialog__header {\n  padding: 0;\n  border-bottom: 1px solid #ebeef5;\n}\n.ccd-dialog .el-dialog__body {\n  padding: 0;\n}\n.ccd-dialog .el-dialog__footer {\n  padding: 12px 20px;\n  border-top: 1px solid #ebeef5;\n}\n.ccd-dialog .el-form-item {\n  margin-bottom: 14px;\n}\n.ccd-dialog .el-form-item__label {\n  padding-bottom: 4px;\n  line-height: 1.4;\n}\n", ""]);
// Exports
module.exports = exports;
